export default __webpack_public_path__ + "static/designer-jordan-grimes-0c79ca7a9fca00b97ee4f57256c619a3.png";